import CompanyLocation from './CompanyLocation';
import TestRestaurant from './TestRestaurant';

export default {
  CompanyLocation,
  TestRestaurant,
};
